import { useCreateAccountPayable } from 'api-hooks/account-payable';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import { NavigationProps } from 'types';

import AccountPayableForm from './components/form';

export type AccountPayableCreateParams = null;

export default function AccountPayableCreate(
  props: NavigationProps<NavigationRoutes.AccountPayablesCreate>,
) {
  const { mutateAsync, error } = useCreateAccountPayable();

  const onResolve = useApprovalableEdit('account-payables');

  return (
    <>
      {!!error && !!error.message && (
        <>
          <Notification
            overrides={{
              Body: { style: { width: 'auto', wordBreak: 'break-all' } },
            }}
            kind={KIND.negative}
            closeable
          >
            {() => error.message}
          </Notification>
          <SeparatorVertical $margin={8} />
        </>
      )}
      <AccountPayableForm
        {...props}
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
